import React, { useEffect, useState } from "react";
import CalendarAssorts from "../Assorts";
import CalendarExerciseChoice from "../ExerciseChoice";
import useCalendarSale from "../hooks/useCalendarSale";
import "./style.scss";
import { useMediaQuery } from "@mui/material";
import { Exercise } from "../../../models/Exercise";
import { BsClock } from "react-icons/bs";
import format from "date-fns/format";
import ModalComponent from "../../../../features/ModalComponent";
import { useTranslation } from "react-i18next";

interface IProps {
  exerciseName?: string;
  exercise: Exercise[];
  refreshCapacityAfterAddTicket: () => void;
  joinToExerciseByPass: (exerciseIds: string, assignType: boolean, passId: number) => void;
  clicked?: number;
  alertCalendar: string;
}

const CalendarMultiExercise: React.FC<IProps> = ({ exercise, clicked, refreshCapacityAfterAddTicket, joinToExerciseByPass, alertCalendar }: IProps) => {
  const { t } = useTranslation();
  const { getTicketsByExercise, tickets, ticketLimit, ticketAccess, chooseTime, getDetailsAboutExercise, exerciseDetails } = useCalendarSale();
  const [openHours, setOpenHours] = useState(false);
  const [whichClicked, setClicked] = useState(99);
  const handleCloseModal = (boolean: boolean) => {
    setOpenHours(boolean);
  };

  useEffect(() => {
    setClicked(99);
  }, [exercise]);

  const handleWhichClicked = (index: number) => {
    setClicked(index);
  };


  const getDetailsAboutClickedExercise = (exerciseId: number) => {
    getDetailsAboutExercise(exerciseId)
  }

  const [click, wasClicked] = useState(clicked);
  const matches = useMediaQuery("(min-width: 1100px)");
  return (
    <React.Fragment>
      {matches ? (
        <React.Fragment>
          <div className="box exercises shadow border">
            <CalendarExerciseChoice
              getDetailsAboutClickedExercise={getDetailsAboutClickedExercise}
              exercise={exercise}
              getTicketsByExercise={getTicketsByExercise}
              handleWhichClicked={handleWhichClicked}
              whichClicked={whichClicked}
            />
          </div>
{tickets.length ? (   <div className="box tickets shadow border">
            <CalendarAssorts 
            alertCalendar={alertCalendar}
            exerciseDetails={exerciseDetails}
            joinToExerciseByPass={ joinToExerciseByPass}
             tickets={tickets} ticketAccess={ticketAccess} ticketLimit={ticketLimit}
              refreshCapacityAfterAddTicket={refreshCapacityAfterAddTicket} />
          </div>) : (<div className=" tickets"></div>)}
       
        </React.Fragment>
      ) : (
        <React.Fragment>
          <div className="calendar-modal-steps">
            <div className="step flex-start-center">
              <b>2</b>
              <span>{t("godzina_wejscia")}</span>
            </div>
          </div>

          <div className="box flex-between-center">
            <div className="flex-start-center">
              <BsClock className="box-icon" />
              <div className="box-text">
                <span>{t("godzina_wejscia")}</span>
                {click === 0 || click === 1 ? <span>{t("nie_wybrano")}</span> : <b>{format(chooseTime, `HH:mm`)}</b>}
              </div>
            </div>

            {click === 0 ? (
              <button className="button medium padding-small button-fill-disable">{t("wybierz")}</button>
            ) : (
              <React.Fragment>
                {click === 1 && (
                  <button
                    onClick={() => {
                      setOpenHours(!openHours);
                      wasClicked(2);
                    }}
                    className="button medium padding-small button-fill-main"
                  >
                    {t("wybierz")}
                  </button>
                )}
                {click === 2 && (
                  <button
                    onClick={() => {
                      setOpenHours(!openHours);
                      wasClicked(2);
                    }}
                    className="button medium padding-small button-fill-background-main"
                  >
                    {t("zmien")}
                  </button>
                )}
              </React.Fragment>
            )}
          </div>

          <div className="calendar-modal-steps">
            <div className="step flex-start-center">
              <b>3</b>
              <span>{t("wybierz_rodzaj_i_ilosc_biletow")}</span>
            </div>
          </div>
          {click === 2 && <CalendarAssorts
          alertCalendar={alertCalendar}
           exerciseDetails={exerciseDetails}
            joinToExerciseByPass={ joinToExerciseByPass}
          tickets={tickets} ticketAccess={ticketAccess} ticketLimit={ticketLimit} refreshCapacityAfterAddTicket={refreshCapacityAfterAddTicket} />}
        </React.Fragment>
      )}

      {openHours && (
        <ModalComponent
          footer={false}
          open={openHours}
          closeModal={() => setOpenHours(false)}
          title={t("wybierz_godzine")}
          onAccept={() => setOpenHours(false)}
        >
          <div className="flex-start flex-wrap">
            <CalendarExerciseChoice
            getDetailsAboutClickedExercise={getDetailsAboutClickedExercise}
              exercise={exercise}
              getTicketsByExercise={getTicketsByExercise}
              handleCloseModal={handleCloseModal}
              handleWhichClicked={handleWhichClicked}
              whichClicked={whichClicked}
            />
          </div>
        </ModalComponent>
      )}
    </React.Fragment>
  );
};

export default CalendarMultiExercise;
